import { useEffect, useState } from 'react';

/**
 * Abonnement réactif léger à une media query, sans dépendance ajoutée. Utilisé pour le point de
 * rupture responsive (`(max-width: 720px)`) et pour refléter `prefers-reduced-motion` /
 * `prefers-contrast` — jamais lu une seule fois via `window.innerWidth`.
 * Sûr hors navigateur (SSR, tests sans `window.matchMedia`) : retombe sur `false`.
 */
export function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => queryMatches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mediaQueryList = window.matchMedia(query);
    const update = () => setMatches(mediaQueryList.matches);
    update();
    mediaQueryList.addEventListener('change', update);
    return () => mediaQueryList.removeEventListener('change', update);
  }, [query]);

  return matches;
}

function queryMatches(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(query).matches;
}

export const COMPACT_VIEWPORT_QUERY = '(max-width: 720px)';
export const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const PREFERS_CONTRAST_MORE_QUERY = '(prefers-contrast: more)';
